export default {
  authentication: {
    errors: {
      sign_out: 'Ocurrió un error al cerrar tu sesión',
    },
  },
};
